import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class FornecedoresService {
    constructor(
        private apiService: ApiService
    ) {}
    
    get(id): Observable<any> {
        let url : string = `/fornecedores/${id}`
        return this.apiService.get(url)
    }
    
    getAll(filtro?): Observable<any> {
        let url : string = `/fornecedores`
        return this.apiService.get(url, filtro)
    }
    
    restore(id) : Observable<any> {
        return this.apiService.get('/fornecedores/reativar/' + id)
    }
    
    post(form) : Observable<any> {
        return this.apiService.post('/fornecedores', form)
    }
    
    put(id: string, form) : Observable<any> {
        form._method = 'PUT'
        return this.apiService.post('/fornecedores/' + id, form)
    }
    
    deleteFornecedores(id) {
        return this.apiService.delete('/fornecedores/' + id)
    }
}